export const chat = {
  copyMessage: "Copiar mensagem",
  reprompt: "Reprompt",
  placeholder: "Digite sua mensagem...",
  loadMoreMessages: "Carregar mais mensagens",
  editSystemPrompt: "Editar prompt do sistema",
  messageCopied: "Mensagem copiada",
  dashboard: {
    title: "Painel",
  },
  chat: {
    title: "Chat",
  },
  modelSelect: {
    modelHelpText: "Selecionar modelo",
    providerHelpText: "Selecionar provedor",
  },
  slides: {
    helpText: "Configurar geração de slides",
    numSlides: "Número de slides",
    template: "Template de slides",
  },
  types: {
    basic: "Chat Básico",
    multiChat: "Chat Comparativo",
    generationChat: "Chat de Geração de IA",
    imageGeneration: "Geração de Imagem",
    videoGeneration: "Geração de Vídeo",
    presentation: "Apresentação de Slides",
    buuAgent: "Chat com Agente Buu Digital",
    agent: "Agente",
    character: "Personagem",
    dataMining: "Mineração de Dados",
    audioGeneration: "Geração de Áudio",
    musicGeneration: "Geração de Música",
  },
  memory: {
    helpText: "Definir memória",
    prompt: "Definir memória (0-1000):",
  },
  modelInfo: {
    all: "Todos",
    close: "Fechar",
    loadMore: "Carregar mais",
    filterByCapability: "Filtrar por capacidade",
    filterByProvider: "Filtrar por provedor",
    showDisabled: "Mostrar desabilitados",
    free: "Gratuito",
    disabled: "Desabilitado",
    helpText: "Informações de modelos e serviços de IA",
    title: "Preços de Serviços Integrados",
    description: "Descrição do modelo",
    capabilities: "Capacidades",
    inputCost: "Custo de entrada por 1M tokens:",
    outputCost: "Custo de saída por 1M tokens:",
    costPerGeneration: "Custo por evento:",
    sortByCost: "Ordenar por custo",
    costLowToHigh: "Custo: Menor para Maior",
    costHighToLow: "Custo: Maior para Menor",
    notice:
      "Alguns modelos podem ter restrições regionais com base nas políticas dos provedores. Modelos gratuitos têm limites diários de uso.",
    pricing: {
      perMillion: "por 1M tokens",
    },
    toolCalling: "Ferramentas",
    reasoning: "Raciocínio",
    vision: "Visão",
    embedding: "Embedding",
    image: "Imagem",
    video: "Vídeo",
    chat: "Chat",
    music: "Música",
    multimodal: "Multimodal",
    textToSpeech: "Texto para Fala",
    reranking: "Reranking",
    dataMining: "Mineração de Dados",
  },
  imageSettings: {
    helpText: "Configurações de imagem",
    title: "Configurações de imagem",
    modelSearch: "Pesquisar modelos da CivitAI",
    viewModelOnCivitai: "Ver modelo na CivitAI",
    selectedRunwareModel: "Modelo selecionado da CivitAI",
    negativePromptToggle: "Mostrar prompt negativo",
    negativePrompt: "Prompt negativo",
    negativePromptHelpText:
      "Um prompt negativo é uma frase ou palavras que descrevem o que o modelo deve evitar. Por exemplo, se você quer uma imagem de um cachorro, você não quer uma imagem de um gato, então o prompt negativo seria 'gato'.",
    negativePromptPlaceholder: "Digite o prompt negativo...",
    hd: "HD",
    size: "Tamanho",
    sizeHelpText:
      "Ajuste as dimensões da imagem gerada especificando sua largura e altura em pixels, ou selecione a partir das opções predefinidas. As dimensões da imagem devem ser múltiplas de 64 (exemplo: 512x512, 1024x768).",
    format: "Formato",
    numImages: "Número de imagens",
    numImagesHelpText:
      "Especifique quantas imagens você deseja gerar em uma única solicitação. Cada geração de imagem será cobrada separadamente.",
    width: "Largura",
    height: "Altura",
    steps: "Passos",
    stepsHelpText:
      "Passos são as iterações que um modelo passa para gerar uma imagem. O número de passos determina a qualidade e detalhe da imagem, mas também aumenta o tempo/custo para gerar a imagem",
    cfgScale: "Cfg Scale",
    cfgScaleHelpText:
      "Ajusta quão próxima a imagem gerada se alinha com o prompt de entrada. Um valor maior força uma maior fidelidade ao prompt, enquanto um valor menor permite mais liberdade criativa.",
    scheduler: "Scheduler",
    schedulerHelpText:
      "Selecione o scheduler para a geração da imagem. Diferentes schedulers influenciam como o modelo se aproxima de refinar a imagem, afetando estilo e qualidade.",
    seed: "Seed",
    seedHelpText:
      "Um número aleatório usado para inicializar o processo de geração de imagem, para ter resultados consistentes/semelhantes, defina o mesmo seed para o mesmo prompt.",
    strength: "Força",
    strengthHelpText: "Força para a geração da imagem",
    advancedControls: "Controles avançados",
    decorType: "Tipo de decoração",
    decorTypeHelpText:
      "Selecione Prime para acabamentos de parede, Stage para decoração de interiores",
    uploadImage: "Carregar imagem",
    uploadReferenceImage: "Carregar imagem de referência",
    imageUrl: "URL da imagem",
    dragAndDrop: "Arraste e solte para adicionar imagem",
    roomType: "Tipo de cômodo",
    roomTypes: {
      livingroom: "Sala de estar",
      kitchen: "Cozinha",
      diningroom: "Sala de jantar",
      bedroom: "Quarto",
      bathroom: "Banheiro",
      kidsroom: "Quarto de crianças",
      familyroom: "Sala de família",
      readingnook: "Ninho de leitura",
      sunroom: "Sala de sol",
      walkincloset: "Guardaroupa",
      mudroom: "Sala de vestuário",
      toyroom: "Sala de brinquedos",
      office: "Sala de escritório",
      foyer: "Hall",
      powderroom: "Banheiro",
      laundryroom: "Lavanderia",
      gym: "Academia",
      basement: "Fundos",
      garage: "Garagem",
      balcony: "Balcão",
      cafe: "Café",
      homebar: "Bar de casa",
      study_room: "Sala de estudo",
      front_porch: "Portão",
      back_porch: "Portão de trás",
      back_patio: "Pátio de trás",
    },
    designStyle: "Estilo de design",
    designStyles: {
      minimalist: "Minimalista",
      scandinavian: "Escandinavo",
      industrial: "Industrial",
      boho: "Boho",
      traditional: "Tradicional",
      artdeco: "Art Deco",
      midcenturymodern: "Moderno do século 20",
      coastal: "Costeiro",
      tropical: "Tropical",
      eclectic: "Ecletico",
      contemporary: "Contemporâneo",
      frenchcountry: "Francês",
      rustic: "Rústico",
      shabbychic: "Shabby Chic",
      vintage: "Vintage",
      country: "Rural",
      modern: "Moderno",
      asian_zen: "Zen Asiático",
      hollywoodregency: "Regência de Hollywood",
      bauhaus: "Bauhaus",
      mediterranean: "Mediterrâneo",
      farmhouse: "Fazenda",
      victorian: "Victória",
      gothic: "Gótico",
      moroccan: "Marrroquino",
      southwestern: "Sudeste",
      transitional: "Transicional",
      maximalist: "Maximalista",
      arabic: "Árabe",
      japandi: "Japão-Brasil",
      retrofuturism: "Retrofuturismo",
      artnouveau: "Art Nouveau",
    },
    colorScheme: "Esquema de cores",
    specialityDecor: "Decoração especial",
    scaleFactor: "Fator de escala",
    colorSchemes: {
      colorScheme0: "Padrão",
      colorScheme1: "Verde-Moss, Bege, Branco",
      colorScheme2: "Cinza, Areia, Azul",
      colorScheme3: "Verde-Caçador, Vermelho",
      colorScheme4: "Branco, Pops de cores",
      colorScheme5: "Azul, Neon",
      colorScheme6: "Azul-Claro, Esmeralda",
      colorScheme7: "Azul, Verde-Grama",
      colorScheme8: "Azul, Bege",
      colorScheme9: "Cinza, Marrom",
      colorScheme10: "Preto, Vermelho",
      colorScheme11: "Cinza-Verde, Branco, Preto",
      colorScheme12: "Azul, Cinza, Taupe",
      colorScheme13: "Preto, Azul",
      colorScheme14: "Esmeralda, Bege",
      colorScheme15: "Verde-Floresta, Cinza-Claro",
      colorScheme16: "Amarelo, Cinza",
      colorScheme17: "Rosa, Verde",
      colorScheme18: "Rosa-Claro, Preto",
      colorScheme19: "Preto, Branco",
      colorScheme20: "Azul, Branco",
    },
    specialityDecors: {
      specialityDecor0: "Nenhuma",
      specialityDecor1:
        "Decoração de Halloween com ambiente assustador, elementos assustadores, cores escuras e acentos festivos",
      specialityDecor2:
        "Decoração de Natal com árvore de Natal, ornamentos e luzes",
      specialityDecor3:
        "Decoração de Dia de Ação de Graças, Decoração de outono",
      specialityDecor4: "Decoração de outono",
      specialityDecor5: "Decoração de primavera",
      specialityDecor6: "Decoração de verão",
      specialityDecor7: "Decoração de inverno",
    },
  },
  newSession: "Novo(a)",
  newChat: "Novo Chat",
  temperature: {
    helpText: "Definir temperatura",
    prompt: "Definir temperatura (0-2):",
  },
  you: "Você",
  ai: "IA",
  system: "Sistema",
  deleteMessage: "Excluir mensagem",
  systemMessageUpdated: "Prompt do sistema atualizado com sucesso",
  deleteSession: "Excluir sessão",
  renameSession: "Renomear sessão",
  sessionNamePlaceholder: "Digite o nome da sessão...",
  sendMessage: "Enviar mensagem",
  expand: "Expandir entrada",
  collapse: "Recolher entrada",
  credits: {
    view: "Ver Detalhes de Uso",
    balance: "Créditos: ${{amount}}",
  },
  numChats: {
    select: "Selecione a quantidade de chats que você deseja ter nesta sessão",
    reset: "Resetar",
    warning:
      "Alterando a quantidade de colunas, o chat comparativo será resetado, TODAS AS MENSAGENS SERÃO PERDIDAS, você tem certeza?",
  },
  errors: {
    creditsExceeded:
      "Você excedeu seu limite de créditos. Por favor, atualize sua assinatura ou adicione créditos para continuar usando o serviço.",
    generic: "Ocorreu um erro ao gerar a resposta. Por favor, tente novamente.",
    failed: "Falha ao enviar mensagem",
  },
  agentChat: {
    changeAgent: "Mudar Agente",
  },
};
